import React, { Component } from 'react';
import moment from 'moment';
import Config from '../Config'
import Phone from '../components/Phone'
import './css/overview.css';

class Overview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      filteredItems: [],
      isLoaded: false,
      isLoadError: false,
      isOldData: false,
      filter: ''
    };

    // hold the currently loaded user for the component
    this.loadedUser = "";
    this.loadedDate = null;
  }

  static cachedOverview = null;


  componentDidMount() {
    // load data 
    this.loadData(this.props.selectedUser, this.props.selectedDate);
  }
  componentDidUpdate() {
    this.loadData(this.props.selectedUser, this.props.selectedDate);
  }

  writeTime(n) {
    return moment(n).format('HH:mm')
  }

  clearToken() {
    this.props.notifyTokenExpired(Config.token);
    Config.token = "abc";
    this.loadData(this.props.selectedUser, this.props.selectedDate);
  }
  reload() {
    this.setState({ isLoaded: false });
    const user = this.loadedUser;
    this.loadedUser = null;
    this.loadData(user, this.loadedDate);
  }

  loadData(selectedUser, selectedDate) {
    if (selectedUser === this.loadedUser && selectedDate === this.loadedDate) return;
    this.loadedUser = selectedUser;
    this.loadedDate = selectedDate;

    this.setState({ isLoadError: false, items: [], isOldData: false });

    // check if the version.json file matches the current running version
    var check = "version.json?d=" + new Date().valueOf();

    fetch(check)
      .then((r) => { var s = r.json(); return s; })
      .then((data) => {
        console.log("version check", data);
        if (Config.Version !== data.version) {
          // file not found, so there is a version mismatch
          this.setState({ mode: "versionmismatch" });
        }
      })


    this.url = Config.DigibonServiceBase + "overview?date=" + moment(selectedDate).format('YYYY-MM-DD') + "&userCode=" + selectedUser;

    fetch(this.url, Config.GetBearer())
      .then((res) => { return res.ok ? res.json() : { status: res.status } })
      .then((json) => {
        if (json.status === 401) {
          alert("Het is noodzakelijk opnieuw in te loggen");
          this.props.notifyTokenExpired(Config.token);
          this.useCachedData();
          return;
        } else if (json.status === 500) {
          this.useCachedData();
          return;
        }

        Overview.cachedOverview = json;
        console.log("overview", json);
        this.setState({
          items: json,
          filteredItems: this.applyFilter(json, this.state.filter),
          isLoaded: true
        });

      }).catch((error) => {
        // not loaded, we continue with the old data if available
        this.useCachedData();
      });

  }

  useCachedData() {


    if (Overview.cachedOverview) {
      this.setState({
        items: Overview.cachedOverview,
        filteredItems: this.applyFilter(Overview.cachedOverview, this.state.filter),
        isLoaded: true,
        isOldData: true
      });

    } else {
      this.setState({
        isLoadError: true
      });
    }
  }

  changeFilter(evt) {
    const value = evt.target.value;
    this.setState({ filter: value, filteredItems: this.applyFilter(this.state.items, value) });
  }

  applyFilter(items, filter) {
    if (filter === '1') return items.filter(p => p.serviceCall.status === 1);
    if (filter === '-1') return items.filter(p => p.serviceCall.status === -1);
    return items;
  }
  GetTimeClass(days, time) {
    if (days !== 0) return "";

    // only give a color to a time when date is today
    var d = new Date();
    var t = moment(time);
    d.setHours(t.hour());
    d.setMinutes(t.minutes());

    if (d < new Date()) return "late";
    return "ontime";
  }

  render() {
    if (this.state.mode === "versionmismatch") {
      return <div>Er is een nieuwe versie beschikbaar. Ververs de browser voor de laatste versie. </div>
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const days = moment(this.props.selectedDate).diff(today, 'days');

    if (this.state.isLoadError) {
      return <div>Er is een fout opgetreden bij het ophalen van gegevens<br />
        <br />
        <button className="btn btn-primary" onClick={this.loadData.bind(this)}>probeer opnieuw</button>

      </div>
    }
    if (!this.state.isLoaded) {
      return <div>Loading..</div>
    }


    const items = this.state.filteredItems ?? [];


    const header = <b className="d-none d-lg-block"><div className="row font-weight-bold">
      <div className="col">Service ID</div>
      <div className="col">MB Code / KEK</div>
      <div className="col">Centrale</div>
      <div className="col">Plantijd</div>
      <div className="col">Klant</div>
      <div className="col">Bezoekadres</div>
    </div></b>

    const listItems = items.map((item, index) => {
      const bp = item.serviceCall.businessPartner;
      var className = "overview-container ";
      if (item.serviceCall.statusName === "Afgesloten") {
        // mark closed serviceCall
        className += " closed";
      } else if (item.processes && item.processes.filter(p => p.createDate && !p.processedDate).length > 0) {
        // this item is still in process of being stored
        className += " processing";
        item.serviceCall.statusName = "bezig met verwerking...";
      }

      // find pa 
      const currentPA = item.equipmentCards && item.equipmentCards.find(p => p.status === 'L' && p.item && !p.item.IsHomeAccess);


      var cp=null;
      if (item.contactPersons) cp=item.contactPersons.find(p=> p.internalCode===item.serviceCall.contactCode);

      return <div key={item.serviceCall.documentNumber + "_" + index} className={className} onClick={() => this.props.SelectBon(item)}>
        <div className="mt-2 " >
          <div className="row">
            <div className="col">
              <p><span className="d-lg-none  no-print">Onderwerp: </span>
                <b>{item.serviceCall.subject}</b>


                <span className="ms-2">
                  {item.serviceCall.description !== null && item.serviceCall.description !== '' &&
                    item.serviceCall.subject !== item.serviceCall.description && <span>({item.serviceCall.description})</span>}

                </span>
              </p>

            </div>
          </div>

        </div>
        <div className="row mb-2" >
          <div className="col-lg col-md-6 col-sm-2">
            <div><span className="d-lg-none no-print">Document nummer: </span>{item.serviceCall.documentNumber}</div>
            <div><span className="d-lg-none no-print">Status: </span>{item.serviceCall.statusName}</div>

          </div>
          <div className="col-lg col-md-6 col-sm-2"><span className="d-lg-none">MB-code: </span>{bp.reportingCenterCode1} {bp.reportingCenterCode2}
            {currentPA && <div>
              <div className="d-lg-none no-print"><b>Huidig personenalarm:</b> </div>
              <div>{currentPA.number} ({currentPA.firmName} {currentPA.item.code})</div>
              <div>s/n: {currentPA.serialNumber}</div>
            </div>}

          </div>
          <div className="col-lg col-md-6 col-sm-2"><span className="d-lg-none">Alarm centrale: </span>{bp.emergencyCenter.name}</div>
          <div className="col-lg col-md-6 col-sm-2">
            <span className={this.GetTimeClass(days, item.serviceCall.startTime)}>
              {this.writeTime(item.serviceCall.startTime)} / {this.writeTime(item.serviceCall.endTime)}
            </span>
          </div>

          <div className="col-lg col-md-6 col-sm-2">
            <span className="d-lg-none no-print"><b>Klant:</b> </span>
            <div>{bp.shippingAddress.name}</div>
            <div><span className="font-weight-bold h5">{bp.cardCode} </span> </div>
            {cp &&
              // we can only show the contact person only when there is at least one
              <div >{cp.relationName ?
                cp.relationName + ": " : ""}
                <span className="me-2">{cp.name.firstName} </span>
                <table><tbody><tr><td><Phone value={cp.contact.phone1}></Phone></td><td>
                </td></tr></tbody></table>


              </div>
            }
            <div>{item.cardCode}</div>
          </div>
          <div className="col-lg col-md-6 col-sm-2">
            <div className="d-lg-none  no-print"><b>Bezoekadres:</b> </div>
            <div>{bp.shippingAddress.street} {bp.shippingAddress.streetNumber} {bp.shippingAddress.building}</div>
            <div>{bp.shippingAddress.zipCode} {bp.shippingAddress.city}</div>
            <div>
              {bp.contact.phone1 &&
                    <Phone value={bp.contact.phone1}></Phone>
              }
            </div><div>
              {bp.contact.mobile &&
                <Phone value={bp.contact.mobile}></Phone>
              }
            </div>
          </div>
        </div>

        <div className="mt-2"><i>{item.serviceCall.technicalRemarks}
          {item.orders && item.orders.some(p => p.lines.some(l => l.item.isHomeAccess)) &&
            <span className="ms-4">Woningtoegang
              {item.orders && item.orders.some(p => p.lines.some(l => l.item.isHomeAccess && l.item.isBuy)) &&
                <span> koop</span>
              }
              {item.orders && !item.orders.some(p => p.lines.some(l => l.item.isHomeAccess && l.item.isBuy)) &&
                <span> huur</span>
              }
            </span>

          }
        </i></div>

        {item.pictureCount > 0 && <div className="text-end me-4">
          <span className="bg-secondary text-white ps-2 pe-2 small badge">{item.pictureCount}</span>
          {item.pictureCount > 1 && <span> foto's</span>}
          {item.pictureCount === 1 && <span> foto</span>}
        </div>}
      </div>
    });

    return (
      <div>
        <div className="row">
          <div className="col">
            <div className="row">
              <div className="col-auto">
                <h4>{moment(this.props.selectedDate).format('DD-MM-YYYY')}   </h4>
              </div>
              <div className="col-auto mt-1">
                {days > 1 && <span>
                  (over {days} dagen)
                </span>}
                {days < -1 && <span>
                  ({Math.abs(days)} dagen geleden)
                </span>}
                {days === 1 && <span>
                  (morgen)
                </span>}
                {days === -1 && <span>
                  (gisteren)
                </span>}

              </div>
              <div className="col">
                <i className="ms-4 fa fa-refresh clickable no-print" title="Klik om te verversen" onClick={this.reload.bind(this)} ></i>
              </div>
            </div>

          </div>
          <div className="col">
            <span className="bg-secondary text-white ps-2 pe-2 small badge">{items.length}</span> afspraken
          </div>
          <div className="col text-end no-print">

            Filter: <select onChange={this.changeFilter.bind(this)}>
              <option value=''>Toon alles</option>
              <option value='1'>Gepland</option>
              <option value='3'>Tijd nog bevestigen</option>
              <option value='13'>Project</option>
              <option value='-1'>Afgesloten</option>
            </select>
          </div>

        </div>
        {(items === null || items.length === 0) &&
          <div>Geen gegevens gevonden {
            this.state.filter === "-1" ? "voor filter afgesloten" :
              this.state.filter === "1" ? "voor filter gepland" :
                ""
          }</div>
        }


        {this.state.isOldData && <div className="text-danger">Er worden oude gegevens getoond, klik <span onClick={this.loadData.bind(this)} >hier</span> om te verversen</div>}
        {items !== null && items.length > 0 &&
          <div>
            {header}
            {listItems}
          </div>
        }
      </div>
    );


  }

}

export default Overview;






